import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FieldKey } from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';
import { isEmpty, toLower } from 'lodash';

export const matchFieldValidator =
  (firstFieldKey: FieldKey, secondFieldKey: FieldKey, caseInsensitiveValidation: boolean = true): ValidatorFn =>
  (form: AbstractControl): ValidationErrors | null => {
    const firstFieldFormControl = form.get(firstFieldKey);
    const secondFieldFormControl = form.get(secondFieldKey);

    const firstFieldValue = firstFieldFormControl?.value;
    const secondFieldValue = secondFieldFormControl?.value;

    if (isEmpty(firstFieldValue) || isEmpty(secondFieldValue)) {
      return null;
    }

    const isFieldMatch = caseInsensitiveValidation
      ? toLower(firstFieldValue) === toLower(secondFieldValue)
      : firstFieldValue === secondFieldValue;

    const firstFieldMatchError = isFieldMatch ? null : { ...firstFieldFormControl.errors, invalidFieldMatch: true };

    firstFieldFormControl.setErrors(firstFieldMatchError);

    return isFieldMatch
      ? null
      : {
          invalidFieldMatch: true
        };
  };
